import { _, $, Backbone } from "../../../../vendor";
import { Backform, Biscuit, Notification } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";

import OffCanvasBehavior from "../../../behaviors/Behavior.OffCanvas";

import PaymentAccount from "../../../models/PaymentAccount";

import PaymentAccountFormTpl from "../../../templates/myInbooma/PaymentAccountFormTpl.html";
import { appRollingLoaderAnim } from "../../AppAnnouncements";

export default InboomaBaseView.extend({
  el: ".inb-paymentAccount-form-modal",
  template: PaymentAccountFormTpl,

  ui: {
    errorMessageField: ".off-canvas__form-error",
  },

  initialize() {
    /* const cookies = new Cookies();

        const CreateAccount = InboomaBaseModel.extend({
         });

        const createAccount = new CreateAccount();
        
        createAccount.save({ 
          client_id : cookies.get('user.client_id'),
          success : (model, reponse) => {
            console.log('set account', response)

            new Notification({
              message : that.t('added_${a}',{a:that.t('account')}),
              duration : 5000,
              closeable : true,
              icon : 'fi fi-check'
            });

          },
          error : (model, response) => {
            console.log('error setting acc', response);

            new Notification({
              message : that.t('request_error'),
              duration : 5000,
              closeable : true,
              icon : 'fi fi-x'
            });

          }
        })*/

    this.render();
  },

  onRender() {
    this.getUI("errorMessageField").addClass("hide");

    const that = this,
      fields = [
        {
          name: "account_holder_name",
          label: this.t("account_holder_name"),
          required: true,
          default: Biscuit.get("user.first_name") + " " + Biscuit.get("user.last_name"),
          control: "input",
          size: {
            large: "6",
          },
        },
        {
          name: "account_ibn_number",
          label: this.t("account_iban_number"),
          required: true,
          control: "input",
          size: {
            large: "6",
          },
          helpMessage: this.t("account_iban_number_info"),
        },
        {
          name: "bank_code",
          label: this.t("bank_code"),
          required: false,
          control: "input",
          size: {
            large: "6",
          },
          helpMessage: this.t("bank_code_info"),
        },
        {
          label: this.t("save"),
          control: "button",
          extraClasses: ["expanded button-submit"],
        },
      ],
      paymentAccountModal = new Foundation.Reveal(this.$el),
      form = new Backform.Form({
        el: that.$el.find(".inb-paymentAccount-form__content"),
        model: that.model,
        fields: fields,

        events: {
          submit() {
            return false;
          },

          "click .button-submit"(ev) {
            ev.preventDefault();
            /*that.$el.find('form .is-invalid-input').removeClass('is-invalid-input');

                      $(that.$el.find('form')).foundation('validateForm');
*/
            if (typeof that.model != "undefined") {
              that.$el.find('form button[type="submit"]').prepend(appRollingLoaderAnim);

              that.model = OffCanvasBehavior.prototype.normalizeModel(that.model);

              const isNew = this.model.get("id") == "" || this.model.get("id") == null;

              that.model.urlRoot = isNew
                ? "/connects/addStripeBankAccount"
                : "/connects/updateStripeBankAccount/" + this.model.get("id");

              delete that.model.attributes.id;
              delete that.model.attributes.account;
              delete that.model.attributes.bank_name;
              delete that.model.attributes.stripe_bank_id;
              delete that.model.attributes.stripe_publishable_key;
              delete that.model.attributes.stripe_secret_key;
              delete that.model.attributes.stripe_customer_id;

              that.model.save(null, {
                type: "POST",
                success(model, response) {
                  if (response.success) {
                    model = new PaymentAccount(response.data.bank_account);

                    that.collection.set(model, { add: true, merge: true, remove: false });
                    paymentAccountModal.close();

                    new Notification({
                      message: that.t("saved_${a}", { a: that.t("payment_account") }, "capital"),
                      duration: 5000,
                      type: "success",
                      closeable: true,
                      icon: "fi fi-marker",
                    });
                  } else {
                    switch (response.error_code) {
                      case 999:
                        // response.data === 'Invalid bic'
                        // || response.data == 'We couldn't find the bank for this account number'

                        that
                          .getUI("errorMessageField")
                          .removeClass("hide")
                          .html(that.t("payment_account_save_error"))
                          .fadeIn("fast");

                        break;
                    }
                  }

                  that.$el.find(".rollingLoader").remove();
                },
                error(model, response, options) {
                  that.$el.find(".rollingLoader").remove();

                  that
                    .getUI("errorMessageField")
                    .removeClass("hide")
                    .html(that.t("request_error"))
                    .fadeIn("fast");
                },
              });
            } else {
              if (typeof that.model != "undefined") {
                that
                  .getUI("errorMessageField")
                  .removeClass("hide")
                  .html(that.t("form_validation_error"))
                  .fadeIn("fast");
              }
            }
          },
        },
      }).render();

    const validateForm = new Foundation.Abide(that.$el.find("form"), { liveValidate: true });

    paymentAccountModal.open();

    this.$el.on("closed.zf.reveal", () => {
      Backbone.history.navigate("finances/payment_accounts", { trigger: true });
      that.unbind();
      delete that.model;
      $(document).off("closed.zf.reveal");
    });
  },
});
